import type { HTMLAttributes } from 'react';
import { cx } from './cx';

export function SmallCap({ className, ...rest }: HTMLAttributes<HTMLSpanElement>) {
  return <span className={cx('smallcap', className)} {...rest} />;
}
